import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "parts/Cards/InfoCards/DefaultInfoCard";
import CenteredBlogCard from "parts/Cards/BlogCards/CenteredBlogCard";
// Image
import bgImage from "assets/images/contact.jpg";
function Information() {
  return (
    <MKBox
      component="section"
      py={12}
      sx={{
        pt: "100px",  // Adds space at the top to avoid overlap with fixed navbar
      }}
    >
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={6}>
            <Grid container justifyContent="flex-start">
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="public"
                    title="Content Marketing"
                    description="Creating Valuable Content to Build Authority and Trust
Content is king, but only when it’s valuable, relevant, and engaging. Our content marketing services focus on crafting high-quality content that resonates with your target audience. From blog posts and articles to infographics and whitepapers, we help you create content that attracts, informs, and builds trust with your customers, ultimately driving long-term brand loyalty and authority.

"
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="public"
                    title="Social Media Marketing"
                    description="Leverage Social Platforms to Build Engagement and Brand Awareness
Social media is a powerful tool for reaching a broad audience, building relationships, and driving traffic to your site. Our social media marketing strategy leverages platforms like Facebook, Instagram, Twitter, LinkedIn, and others to engage with your audience, increase brand awareness, and drive traffic to your website. We manage your social presence with tailored content, strategic campaigns, and regular engagement to build a strong community around your brand."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Pay-Per-Click (PPC) Advertising"
                    description="Drive Instant Traffic with Cost-Effective Paid Search Campaigns
With PPC advertising, you can achieve immediate visibility and drive targeted traffic to your website. We specialize in running paid search campaigns on platforms like Google Ads, Bing Ads, and other networks to help you maximize your ROI. By carefully selecting the right keywords, optimizing your bids, and creating compelling ad copy, we help you achieve your advertising goals while staying within budget."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Email Marketing"
                    description="Crafting Personalized Campaigns to Nurture and Convert Leads
Email marketing remains one of the most effective tools for building customer relationships and driving conversions. We design personalized email campaigns tailored to your audience, nurturing leads and guiding them through the sales funnel. From welcome emails and newsletters to promotional offers and product updates, our email marketing strategy drives engagement and ensures your messages are heard."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Affiliate Marketing"
                    description="Boost Reach and Sales Through Performance-Based Partnerships
Affiliate marketing allows you to leverage a network of partners to promote your products and services. We help you set up and manage affiliate marketing programs, working with affiliates who can drive traffic and generate sales for your business. With performance-based commissions, you only pay for results, making this an effective and cost-efficient marketing strategy."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Influencer Marketing"
                    description="Amplify Your Brand Message with Trusted Influencers
Influencer marketing taps into the power of trusted personalities to amplify your brand message. We help you identify the right influencers within your industry to collaborate with, creating authentic partnerships that boost brand visibility and engagement. By leveraging influencers' reach, we help you connect with larger, more engaged audiences, increasing brand awareness and driving conversions."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Video Marketing"
                    description="Engage Your Audience with Compelling Video Content
Video marketing is one of the most engaging forms of content. From brand stories and product demos to customer testimonials and educational videos, we help you create compelling video content that resonates with your audience and drives conversions. By using video across multiple platforms like YouTube, Instagram, and your website, we help you capture attention, increase engagement, and promote your products or services."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Analytics and Data Analysis"
                    description="Make Data-Driven Decisions to Optimize Campaign Performance
Understanding the performance of your digital marketing efforts is crucial to refining your strategies. Our analytics and data analysis services track key metrics, analyze trends, and provide actionable insights to improve your campaigns. From website traffic and social media engagement to PPC performance and email open rates, we use data to continuously optimize and enhance your marketing strategies."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Conversion Rate Optimization (CRO)"
                    description="Make Data-Driven Decisions to Optimize Campaign Performance
Understanding the performance of your digital marketing efforts is crucial to refining your strategies. Our analytics and data analysis services track key metrics, analyze trends, and provide actionable insights to improve your campaigns. From website traffic and social media engagement to PPC performance and email open rates, we use data to continuously optimize and enhance your marketing strategies."
                  />
                </MKBox>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} lg={4} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <CenteredBlogCard
              image={bgImage}
              title="Get insights"
              description="In today's rapidly evolving digital landscape, staying informed is key to making smart decisions. At HP Tech Solutions, we provide valuable insights into the latest trends, challenges, and opportunities in software development and cybersecurity."
              action={{
                type: "internal",
                route: "/pages/landing-pages/contact-us",
                color: "info",
                label: "Contact",
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
